import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import DocumentPrint from '../../components/print/DocumentPrint';
import { fetchCashMemo, setSelected, clearCurrentCashMemo } from '../../store/modules/cashmemo/cashmemoActions';

const CashmemosView = () => {
    const cashmemoState = useSelector(state => state.cashmemo);
    const dispatch = useDispatch();
    const { id } = useParams();
    const isInitialized = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const actions = {
        fetchSingle: (id) => dispatch(fetchCashMemo(id)),
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
        clearCurrent: () => dispatch(clearCurrentCashMemo())
    };

    const fetchData = useCallback(async (id) => {
        try {
            setIsLoading(true);
            const data = await actions.fetchSingle(id);
            if (data && data.items) {
                const selectedIds = data.items.map(item => item?.item?.id);
                await actions.setItemsSelected({
                    key: 'itemIds',
                    data: selectedIds
                });
            }
        } catch (error) {
            console.error('Error fetching cash memo:', error);
        } finally {
            setIsLoading(false);
        }
    }, [actions]);

    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;
            fetchData(id);
        }
    }, [fetchData, id]);

    useEffect(() => {
        console.log(cashmemoState);
    }, [cashmemoState]);

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentPrint
                                    data={cashmemoState.current}
                                    isLoading={isLoading}
                                    documentType="cashMemo"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CashmemosView;
